import { FtpSchemaTypes } from "@bfc-software/api-schemas";
import { QueryClient } from "@tanstack/react-query";
import { LocalStorage } from "@bfc-software/app-toolbox";
import createFetchClient, { Middleware } from "openapi-fetch";
import createClient from "openapi-react-query";
import { getEnv } from "@bfc-software/bfc-web-ui/environment";

export type JobStatus = FtpSchemaTypes.components["schemas"]["jobStatus"];
export type Job = FtpSchemaTypes.components["schemas"]["job"];
export type JobsResponse = FtpSchemaTypes.components["schemas"]["jobsResponse"];
export type JobDetailResponse =
  FtpSchemaTypes.components["schemas"]["jobDetailResponse"];
export type JobLog = FtpSchemaTypes.components["schemas"]["jobLog"];
export type JobLogDetailResponse =
  FtpSchemaTypes.components["schemas"]["jobLogDetailResponse"];
export type JobStats = FtpSchemaTypes.components["schemas"]["jobsStats"];
export type JobStatsWindow =
  FtpSchemaTypes.components["schemas"]["jobStatsWindow"];
export type JobsByFileType =
  FtpSchemaTypes.components["schemas"]["jobsByFileType"];
export type JobStatsResponse =
  FtpSchemaTypes.components["schemas"]["jobStatsResponse"];

const fetchClient = () => {
  const token = LocalStorage.getGlobalJwt();

  const client = createFetchClient<FtpSchemaTypes.paths>({
    baseUrl: getEnv().ftpServiceBaseUrl,
    credentials: "include",
    headers: {
      "X-ACCESS-KEY": getEnv().authAccessKey,
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    },
  });

  client.use({
    onRequest: ({ request }) => {
      const originalUrl = new URL(request.url);
      if (token && !originalUrl.searchParams.has("token")) {
        originalUrl.searchParams.append("token", token);
      }
      return new Request(originalUrl.toString(), { headers: request.headers });
    },
  } as Middleware);

  return client;
};

export const apiClient = () => createClient(fetchClient());

/** Raw fetch client for imperative (non-hook) usage (mutations, etc.) */
export const rawFetchClient = () => fetchClient();

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: false,
    },
  },
});
